import { translateEnum } from 'aos-helpers/src/helpers/translations/Translations'
import { EnumValues } from 'enum-values'
import { TFunction } from 'i18next'

import { TaskType } from '../TaskType'
import { BaseTask } from './BaseTask'
export interface RefuellingTask extends BaseTask {
    type: TaskType.Refuelling
    refuellingTaskType: RefuellingTaskType
    airplaneType?: string
    vehicleDetails?: string
}

export enum RefuellingTaskType {
    TAKING_SAMPLES = 'TAKING_SAMPLES',
    REGULAR_INSPECTION = 'REGULAR_INSPECTIONS',
    REFUELLING = 'REFUELLING',
    SUPERVISION_ESCORT = 'SUPERVISION_ESCORT',
    LOAD_RECEPTION = 'LOAD_RECEPTION',
    EQUIPMENT_MAINTENANCE = 'EQUIPMENT_MAINTENANCE',
    OTHER = 'OTHER',
}

export const allRefuellingTaskTypes = EnumValues.getValues<RefuellingTaskType>(RefuellingTaskType)

export const translateRefuellingTaskType = (t: TFunction) =>
    translateEnum(t)(RefuellingTaskType, 'refuelling-task-type')
